import { Dayjs } from "dayjs";
import { NegotiationsReportItem } from "../../../api";

export type SortableColumn =
  | "caseName"
  | "raa"
  | "negotiationStartedAt"
  | "taskName"
  | "taskedAt"
  | "dueDate"
  | "taskAssignee"
  | "status";

export type SortDirection = "asc" | "desc";

export type SortRule = {
  column: SortableColumn;
  direction: SortDirection;
};

export type HeadCell = {
  id: SortableColumn;
  label: string;
  widthPct: number;
};

export type RowWithSpans = NegotiationsReportItem & {
  rowNumber?: number;
  groupRowSpan?: number;
  skipCaseColumns?: boolean;
  isLastInCaseGroup?: boolean;
};

export type NegotiationsFiltersState = {
  searchTerm: string;
  caseName: string;
  raa: string;
  taskName: string;
  taskAssignee: string;
  overdue: string;
  dueDateFrom: Dayjs | null;
  dueDateTo: Dayjs | null;
  taskedFrom: Dayjs | null;
  taskedTo: Dayjs | null;
  negotiationStartedFrom: Dayjs | null;
  negotiationStartedTo: Dayjs | null;
};

export type FilterFieldKey = Exclude<
  keyof NegotiationsFiltersState,
  | "dueDateFrom"
  | "dueDateTo"
  | "taskedFrom"
  | "taskedTo"
  | "negotiationStartedFrom"
  | "negotiationStartedTo"
>;

export const EMPTY_FILTERS: NegotiationsFiltersState = {
  searchTerm: "",
  caseName: "",
  raa: "",
  taskName: "",
  taskAssignee: "",
  overdue: "",
  dueDateFrom: null,
  dueDateTo: null,
  taskedFrom: null,
  taskedTo: null,
  negotiationStartedFrom: null,
  negotiationStartedTo: null,
};

export const FILTER_FIELD_LABELS: Record<FilterFieldKey, string> = {
  searchTerm: "Search",
  caseName: "Case",
  raa: "RAA",
  taskName: "Task",
  taskAssignee: "Task Assignee",
  overdue: "Overdue",
};

export const OVERDUE_FILTER_OPTIONS = ["Yes", "No"] as const;

export const SORT_FIELD_OPTIONS: { value: SortableColumn; label: string }[] = [
  { value: "caseName", label: "Case Name" },
  { value: "raa", label: "RAA" },
  { value: "negotiationStartedAt", label: "Negotiation Started" },
  { value: "taskName", label: "Task" },
  { value: "taskedAt", label: "Tasked At" },
  { value: "dueDate", label: "Due Date" },
  { value: "taskAssignee", label: "Task Assignee" },
  { value: "status", label: "Status" },
];

export const SORT_DIRECTION_OPTIONS: { value: SortDirection; label: string }[] = [
  { value: "asc", label: "Ascending" },
  { value: "desc", label: "Descending" },
];

export const DEFAULT_SORT_RULES: SortRule[] = [{ column: "caseName", direction: "asc" }];
